<template>
  <div class="order">
    <div class="titleWrap">
      <div class="setTitle">账单列表</div>
      <el-button class="myBtn" type="primary" plain size="small" v-if="funcData.indexOf('export') > -1" @click="exportOrder">导出</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-select class="select" v-model="villageValue" filterable size="small" placeholder="小区名称" @change="changeSearchVillage" v-if="villageId === ''">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="villageName" disabled size="small" placeholder="小区名称" v-else></el-input>
      <el-select class="select" v-model="building" filterable clearable size="small" placeholder="楼栋" @change="changeSearchBuilding">
        <el-option v-for="item in buildingList" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select class="select" v-model="unit" filterable clearable size="small" placeholder="单元">
        <el-option v-for="item in unitList" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select class="select" v-model="mode" filterable clearable size="small" placeholder="缴费方式">
        <el-option v-for="item in modeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-date-picker class="time" v-model="orderTime" type="month" size="small" placeholder="账单时间"></el-date-picker>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="orderAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="building" label="楼栋" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.building }}栋
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单元" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.unit }}单元
          </template>
        </el-table-column>
        <el-table-column prop="mode" label="缴费方式" min-width="180" :align="align">
          <template slot-scope="scope">
            <span v-if="scope.row.mode === 0">按比例</span>
            <span v-if="scope.row.mode === 1">按次数</span>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="账单时间" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="total" label="账单金额" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="createDate" label="账单生成时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ createDate(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="90" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detail(scope.row.id, scope.row.time, scope.row.total, scope.row.mode)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="orderCurr" :page-sizes="[10, 20, 50]" :page-size="orderSize" :total="orderTotal" @current-change="orderCurrChange" @size-change="orderSizeChange"></el-pagination>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'Order',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      building: '', // 楼栋编号下拉菜单选中value
      buildingList: [], // 楼栋编号下拉菜单
      unit: '', // 单元编号下拉菜单选中value
      unitList: [], // 单元编号下拉菜单
      mode: '', // 缴费方式下拉菜单选中value
      modeList: [], // 缴费方式下拉菜单
      orderTime: '', // 账单时间
      orderAttr: [], // 账单列表
      orderTotal: 0, // 账单总数
      orderSize: 10, // 账单每页条数
      orderCurr: 1 // 账单当前页数
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
    }

    if (this.villageId === '') {
      // 获取小区名称下拉菜单
      this.$http.get(this.$api.village_list, {
        params: {
          pageSize: 9999,
          pageNum: 1
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.villageValue = data.data.list[0].id
          this.villageList = data.data.list

          // 获取楼栋下拉菜单
          this.$http.get(this.$api.building_list, {
            params: {
              orgId: this.villageValue
            }
          }).then((res) => {
            let data = res.data

            if (data.data.success) {
              for (let i = 0; i < data.data.data.length; i++) {
                this.buildingList.push({
                  id: data.data.data[i],
                  value: data.data.data[i] + '栋'
                })
              }
            } else {
              this.$message({
                type: 'error',
                message: data.data.errMsg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
          // 获取账单列表
          this.getOrderList(this.orderCurr, this.orderSize)
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    } else {
      // 获取楼栋下拉菜单
      this.$http.get(this.$api.building_list, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          for (let i = 0; i < data.data.data.length; i++) {
            this.buildingList.push({
              id: data.data.data[i],
              value: data.data.data[i] + '栋'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
      // 获取账单列表
      this.getOrderList(this.orderCurr, this.orderSize)
    }

    this.modeList = [
      {
        id: 0,
        value: '按比例'
      },
      {
        id: 1,
        value: '按次数'
      }
    ]
  },
  methods: {
    getOrderList (page, size) {
      let orderTime = ''
      if (this.orderTime !== null && this.orderTime !== '') {
        let myTime = this.$date1(this.orderTime.toString())
        if (myTime.substr(5, 1) === '0') {
          orderTime = myTime.substr(0, 4) + '年' + myTime.substr(6, 1) + '月'
        } else {
          orderTime = myTime.substr(0, 4) + '年' + myTime.substr(5, 2) + '月'
        }
      }
      let params
      if (this.villageId === '') {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageValue,
          building: this.building,
          unit: this.unit,
          mode: this.mode,
          time: orderTime
        }
      } else {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageId,
          building: this.building,
          unit: this.unit,
          mode: this.mode,
          time: orderTime
        }
      }
      this.$http.get(this.$api.order_list, {
        params: params
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.orderAttr = data.data.list
          this.orderTotal = data.data.total
          this.orderSize = size
          this.orderCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getOrderList(1, this.orderSize)
    },
    exportOrder () {
      let orgId = ''
      let orderTime = ''
      if (this.villageId === '') {
        orgId = this.villageValue
      } else {
        orgId = this.villageId
      }
      if (this.orderTime !== null && this.orderTime !== '') {
        let myTime = this.$date1(this.orderTime.toString())
        if (myTime.substr(5, 1) === '0') {
          orderTime = myTime.substr(0, 4) + '年' + myTime.substr(6, 1) + '月'
        } else {
          orderTime = myTime.substr(0, 4) + '年' + myTime.substr(5, 2) + '月'
        }
      }
      window.open(this.$url + this.$api.order_export + '?orgId=' + orgId + '&building=' + this.building + '&unit=' + this.unit + '&mode=' + this.mode + '&time=' + orderTime)
    },
    detail (id, orderTime, orderCount, orderMode) {
      this.$router.push('orderDetail?id=' + id + '&orderTime=' + orderTime + '&orderCount=' + orderCount + '&orderMode=' + orderMode)
    },
    changeSearchVillage (val) {
      this.building = ''
      this.unit = ''
      this.buildingList = []
      this.unitList = []
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.building_list, {
          params: {
            orgId: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.buildingList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '栋'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeSearchBuilding (val) {
      this.unit = ''
      this.unitList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.villageValue
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.unit_list, {
          params: {
            orgId: myOrg,
            building: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.unitList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '单元'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    orderCurrChange (curr) {
      this.getOrderList(curr, this.orderSize)
    },
    orderSizeChange (size) {
      this.getOrderList(this.orderCurr, size)
    },
    notData (str) {
      return this.$null(str)
    },
    createDate (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.orderCurr - 1) * this.orderSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.order
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-top 12px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .input
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .time
      float left
      margin-top 8px
      margin-left 20px
    .searchBtn
      float left
      margin-top 8px
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      tbody
        tr, th
          color #333
      td
        padding 7px 0
      .cell
        line-height 26px
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
</style>



// WEBPACK FOOTER //
// src/components/order/order.vue